export default "__VITE_ASSET__fSCKD6zJ__"